import './App.css';
import CoursePage from './screens/coursePage/CoursePage';
import HomePage from './screens/homePage/HomePage'

function App() {
  return (
    <div className="App">
      <HomePage/>
    </div>
  );
}

export default App;
